/*
 * @Author: Jason
 * @Date: 2020-07-30 14:03:15
 * @LastEditors: Jason
 * @LastEditTime: 2020-09-16 14:28:13
 */ 
import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'
Vue.use(Router)

import pages from '../common/pages'
// console.log(pages)
const routes = [
	{
		path: '/',
		redirect: '/login'
	},
	{
		path: '*',
		redirect: '/'
	}
]

pages.forEach(item => {
	const componentName = item.componentName
	const children = item.children
	let routeChildren = []
	const _route = {
		path: item.link,
		name: componentName,
		component: require('@/pages/' + componentName).default,
		params: item.params || {},
		meta: { title: item.title || ''}
	}
	if (children && children.length) {
		for (let child of children) {
			routeChildren.push({
				path: child.link,
				name: child.componentName,
				component: require('@/pages/' + child.componentName).default,
				params: child.params || {},
				meta: { title: child.title || ''}
			})
		}
	}
	_route.children = routeChildren
	routes.push(_route)
})

const router = new Router({
	routes: routes
})
const unLoginValidPages = ['Login']
router.beforeEach((to, from, next) => {
	// console.log(to, from.name, store.state.LoginInfo.signed)
	if (from.name && !store.state.LoginInfo.signed && !unLoginValidPages.includes(to.name)) {
		router.replace({name: 'Login'})
		return
	}
	if (to.name === 'Login' && store.state.LoginInfo.signed) {
		router.replace({name: 'Home'})
		return
	}
	next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js